import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import AccountHighlights from 'Components/Account/AccountOverview/AccountHighlights/AccountHighlights';
import AccountReviews from 'Components/Account/AccountOverview/AccountReviews';
import ConfirmAccount from 'Components/Account/ConfirmAccount';
import MarketingBlock from 'Components/Account/AccountOverview/MarketingBlock';
import RecommendedProducts from 'Components/Account/AccountOverview/RecommendedProducts';
import SingleOrder from 'Components/Account/AccountOverview/SingleOrder';
import TwoFactorAuthContainer from 'Components/Account/LoginAndSecurity/TwoFactorAuthContainer';

export default function AccountOverview({
  email,
  siteTheme,
  wishlistNumber,
  reviews,
  reviewsError,
}) {
  return (
    <section className="account-content">
      <ConfirmAccount />
      <div className="title-button-container">
        <div className="title-container">
          <h1>
            <FormattedMessage id="account-overview.heading" defaultMessage="Account Overview" />
          </h1>
        </div>
        <div className="button-container">
          {email}
        </div>
      </div>

      <AccountHighlights wishlistNumber={wishlistNumber} reviews={reviews} />

      <TwoFactorAuthContainer accountReminder />

      <SingleOrder />

      <AccountReviews items={reviews} reviewsError={reviewsError} />

      <RecommendedProducts />

      <MarketingBlock siteTheme={siteTheme} />
    </section>
  );
}

AccountOverview.propTypes = {
  email: PropTypes.string,
  siteTheme: PropTypes.string,
  wishlistNumber: PropTypes.number,
  reviews: PropTypes.arrayOf(PropTypes.object),
  reviewsError: PropTypes.bool,
};

AccountOverview.defaultProps = {
  email: '',
  siteTheme: '',
  wishlistNumber: 0,
  reviews: [],
  reviewsError: false,
};
